import { render, staticRenderFns } from "./EmBindEpcComponent.vue?vue&type=template&id=f797b2b4&"
import script from "./EmBindEpcComponent.vue?vue&type=script&lang=js&"
export * from "./EmBindEpcComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports